module.exports = "img/flags/VE.1319ff1.png";